import { BaseGetRequest } from './core/baseGetRequest';
import { Authentication } from './core/baseRequest';
import { CountriesList, CountriesListDynamicType } from 'acscp/api/models/countriesList';

export class CountriesRequest extends BaseGetRequest<CountriesList> {
    constructor() {
        super('countries', {}, CountriesListDynamicType, Authentication.None);
    }
}
